import { render, staticRenderFns } from "./CommonUserLabel.vue?vue&type=template&id=f716e3d4"
import script from "./CommonUserLabel.vue?vue&type=script&lang=js"
export * from "./CommonUserLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports